import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { OpenTripPlannerFacade, RouteGroups } from '@ridango/components';
import { combineLatest } from 'rxjs';
import { Location } from '@angular/common';
import { BaseComponent } from '@ridango/core';
import Env from '@ridango/core/env';

@Component({
    templateUrl: './explore-route-group-page.component.html'
})
export class ExploreRouteGroupPageComponent extends BaseComponent implements OnInit {
    routesGroups$ = this.openTripPlannerFacade.routesGroups$;
    currentRouteGroup: RouteGroups;

    constructor(
        @Inject('ENV') public env: Env,
        private activatedRoute: ActivatedRoute,
        private openTripPlannerFacade: OpenTripPlannerFacade,
        private location: Location
    ) {
        super();
    }

    ngOnInit() {
        this.initialize();
    }

    public redirectToBack(): void {
        this.location.back();
    }

    private initialize(): void {
        combineLatest([this.activatedRoute.params, this.routesGroups$])
            .pipe(filter(Boolean), takeUntil(this.componentDestroyed$))
            .subscribe(([{ name: routeGroupName }, routesGroups]) => {
                if (routesGroups?.length) {
                    this.currentRouteGroup = routesGroups.find(
                        (routeGroup: RouteGroups) => routeGroup.name === routeGroupName
                    );
                } else {
                    this.openTripPlannerFacade.getRoutesGroups();
                }
            });
    }
}
